import React from 'react';
import { useTranslation } from 'react-i18next';
import { WorkSetsTags } from '../RoutineEditor';
import { MuscleBodyMapLarge } from '../../MuscleBodyMap';

export default function VolumeRail({ totalStats = {}, totalCount = 0, onOpenMuscleDetail, className = '' }) {
  const { t } = useTranslation();
  if (totalCount <= 0) {
    return (
      <div className={`p-4 text-center text-xs text-muted-foreground ${className}`} data-testid="routine-volume-rail">
        {t('routineEditor.noExercisesYet')}
      </div>
    );
  }
  return (
    <div className={`p-4 ${className}`} data-testid="routine-volume-rail">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">
        {t('routineEditor.totalWorkSets', { count: totalCount })}
      </p>
      <div className="flex justify-center mb-4">
        <MuscleBodyMapLarge muscleStats={totalStats} onClick={() => onOpenMuscleDetail?.(totalStats)} />
      </div>
      <WorkSetsTags stats={totalStats} size="sm" />
    </div>
  );
}
